module.exports = __webpack_public_path__ + "media/images/sp/top/soudan_stores-3cc4f08bc3f7481209ecdd289ccd93ff.webp";